module.exports = __webpack_public_path__ + "img/18.b7917701.jpg";